const roleEnum = {
  superAdmin: 'SUPER_ADMIN',
  govtUser: 'GOVERNMENT_USER',
};
Object.freeze(roleEnum);

export default roleEnum;



// WEBPACK FOOTER //
// ./src/components/Auth/role.js